import React from "react";
import Flagship from "../../core/flagship";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Field from "./Field";
import { getFormattedValue, empty, isEqual } from "../../utils/helpers";
import Linkify from "react-linkify";
import "../../styles/singleRecord.scss";
import { Divider, Header, Button, Label, Icon, Modal } from "semantic-ui-react";

class SingleRecordField extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.editField = this.editField.bind(this);
    this.saveField = this.saveField.bind(this);
    this.stopEditing = this.stopEditing.bind(this);
  }

  getInitialState() {
    return {
      editing: false,
      inputValue: this.props.field_value,
      errors: []
    };
  }

  editField(fieldId) {
    if (this.props.readOnly === true || this.props.accessLevel !== 2) {
      return;
    }

    this.setState({ editing: fieldId });
  }

  saveField(e, fieldId) {
    if (this.props.readOnly === true || this.props.accessLevel !== 2) {
      return;
    }

    let self = this;

    let recordId = this.props.recordId;
    let userId = this.props.userId;
    let afterSave =
      typeof this.props.afterSave === "function"
        ? this.props.afterSave
        : function() {};

    let requestData = {
      value: this.state.inputValue
    };
    let label = this.props.label;


    Flagship.post(
      "save-record/" + recordId + "/" + fieldId,
      requestData,
      function(response) {

        if (response.data.success === true) {
          if (response.data.updated === true) {
            // Updated value in DB

            if (!isEqual(requestData.value, response.data.oldValue)) {
              Flagship.event(
                "change",
                {
                  label: label,
                  new: requestData.value,
                  old: self.props.field_value
                },
                recordId,
                userId
              );
            }
            afterSave();

            self.setState({
              editing: false,
              inputValue: requestData.value,
              errors: []
            });

            Flagship.notify("Field saved.");
          }
        } else {
          Flagship.error(
            "Error updating field #" + fieldId + ".",
            recordId,
            userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Error updating field #" + fieldId + ": " + err,
          recordId,
          userId
        );
      }
    );
  }

  updateInputValue(value) {
    this.setState({
      inputValue: value
    });
  }

  stopEditing() {
    this.setState({
      editing: false,
      inputValue: this.props.field_value,
      errors: []
    });
  }

  addError(fieldId) {
    let errors = this.state.errors;

    if (errors.indexOf(fieldId) === -1) {
      errors.push(fieldId);
    }

    this.setState({
      errors: errors
    });
  }

  clearError(fieldId) {
    let errors = this.state.errors;
    for (var i = errors.length - 1; i >= 0; i--) {
      if (errors[i] === fieldId) {
        errors.splice(i, 1);
      }
    }

    this.setState({
      errors: errors
    });
  }

  renderValue(value) {
    if (Array.isArray(value)) {
      return value.map(function(val, i) {
        return <div key={"field-value-sub-val-" + i}>{val}</div>;
      });
    } else {
      return value;
    }
  }

  render() {
    let item = this.props;
    let isEmptyValue =
      typeof item.field_value === "undefined" ||
      item.field_value === "" ||
      item.field_value === null ||
      (Array.isArray(item.field_value) && item.field_value.length === 0);

    if (this.props.readOnly === true || this.props.accessLevel !== 2) {
      if (
        item.show_empty !== 1 &&
        (item.field_value === "" || item.field_value === null)
      ) {
        return null;
      }

      return (
        <div key={item.id} className="single-record-single-field">
          <Label>{item.label}</Label>
          <div className="field-value">
            {item.type === "textarea" ? (
              <Linkify properties={{ target: "_blank" }}>
                {this.renderValue(
                  getFormattedValue(item.field_value, item.validation)
                )}
              </Linkify>
            ) : (
              this.renderValue(
                getFormattedValue(item.field_value, item.validation)
              )
            )}
          </div>
        </div>
      );
    }

    let editField = this.editField;
    if (
      item.show_empty === 1 ||
      (item.field_value !== "" && item.field_value !== null)
    ) {
      const updateModalValue = (e, value) => {
        this.updateInputValue(value);
      };

      let trigger = (
        <div key={item.id} className="single-record-single-field">
          <Label
            className="edit-corner-icon"
            size="large"
            corner="right"
            onClick={() => {
              editField(item.field_id);
            }}
          >
            <Icon className="edit-corner-icon-icon" name="edit" />
          </Label>
          <Label>{item.label}</Label>
          <div className="field-value">
            {isEmptyValue ? (
              <span className="highlighter">Empty</span>
            ) : (
              this.renderValue(
                getFormattedValue(item.field_value, item.validation)
              )
            )}
            {!empty(item.suffix) ? " " + item.suffix : ""}
          </div>
        </div>
      );

      return (
        <Modal
          key={item.key}
          trigger={trigger}
          closeIcon
          open={this.state.editing === item.field_id}
          onClose={this.stopEditing.bind(this)}
        >
          <Modal.Content>
            <Header>Edit Information</Header>
            <Field
              addError={this.addError.bind(this)}
              clearError={this.clearError.bind(this)}
              key={"editRecord-" + item.field_id}
              value={this.state.inputValue}
              onChange={(e, field, id) => updateModalValue(e, field, id)}
              {...item}
            />
            <Divider />
            <Button
              disabled={this.state.errors.length ? true : false}
              onClick={e => this.saveField(e, item.field_id, item.field_value)}
              primary
            >
              Save
            </Button>
            <Button onClick={this.stopEditing}>Cancel</Button>
          </Modal.Content>
        </Modal>
      );
    } else {
      return null;
    }
  }
}

SingleRecordField.propTypes = {
  niceName: PropTypes.string,
  username: PropTypes.string,
  userId: PropTypes.number
};

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    accessLevel: state.main.accessLevel
  };
}

export default connect(mapStateToProps, null)(SingleRecordField);



// WEBPACK FOOTER //
// ./src/components/misc/SingleRecordField.js